import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { Box, Button, Alert, CircularProgress } from "@mui/material";
import { Icon } from "@iconify/react";

// Устанавливаем worker для react-pdf
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

export default function PdfViewer({ url, fileName }) {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  function onDocumentLoadSuccess() {
    setLoading(false);
    setError(null);
  }

  function onDocumentLoadError(error) {
    console.error("Error loading PDF:", error);
    setError("Не удалось загрузить PDF файл");
    setLoading(false);
  }

  const handleDownload = () => {
    try {
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.download = fileName || "document.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading PDF:", error);
      setError("Не удалось скачать PDF файл");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
        p: 2,
        width: "70%",
      }}
    >
      {error && (
        <Alert severity="error" sx={{ width: "100%" }}>
          {error}
        </Alert>
      )}

      {loading && (
        <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
          <CircularProgress />
        </Box>
      )}

      {!error && (
        <Document
          file={url}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={onDocumentLoadError}
          loading={null}
          options={{
            cMapUrl: `//unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
            cMapPacked: true,
            standardFontDataUrl: `//unpkg.com/pdfjs-dist@${pdfjs.version}/standard_fonts/`,
          }}
        >
          <Page
            pageNumber={1}
            width={300}
            renderTextLayer={false}
            renderAnnotationLayer={false}
            loading={
              <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
                <CircularProgress />
              </Box>
            }
          />
        </Document>
      )}

      <Button
        variant="contained"
        startIcon={<Icon icon="mdi:download" />}
        onClick={handleDownload}
        disabled={!!error}
      >
        Скачать PDF
      </Button>
    </Box>
  );
}
